export interface AppConfig {
    REACT_APP_BASEURL: string;
    REACT_APP_ENV: string
}

export function getAppConfig() : AppConfig {
    return (window as any)["runConfig"] as AppConfig;
}